import Popover from "@material-ui/core/Popover";
import React, { Fragment, useContext } from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import { useHistory } from "react-router-dom";

import { ButtonTealContained } from "../../../shared/components/MUIThemed/ButtonTealContained";
import { FileUploadSemantic } from "../../../shared/components/FormElements/FileUploadSemantic";
import { useForm } from "../../../shared/hooks/formHook";
import { SettingsContext } from "../../../shared/context/settingsContext";
import { openWhatsapp } from "../../../shared/util/openWhatsapp";
import { addThousandSeparator } from "../../../shared/util/addThousandSeparator";
import {
  ArchiveData,
  AuthContextProps,
  FinancingData,
} from "../../../shared/data/types";

import { PopoverFormStyles } from "./PopoverFormStyles";
import { ButtonDarkGreyContained } from "../../../shared/components/MUIThemed/ButtonDarkGreyContained";

interface FormUploadDocsProps {
  selOpt: FinancingData["proposals"][0];
}

export const FormUploadDocs = (props: FormUploadDocsProps) => {
  const { selOpt } = props;
  const classes = PopoverFormStyles();
  const gracePeriod = selOpt?.gracePeriod || selOpt?.gracePeriodDays || 0;
  const gracePeriodUnit = !!selOpt?.gracePeriod
    ? gracePeriod === 1
      ? "Mês"
      : "Meses"
    : !!selOpt?.gracePeriodDays
    ? gracePeriod === 1
      ? "Dia"
      : "Dias"
    : "Meses";

  const openWhatsappHandler = () => {
    openWhatsapp(
      "1151926019",
      `Quero contratar este financiamento: ${addThousandSeparator(
        selOpt?.fee < 0.15 ? selOpt?.fee * 100 : selOpt?.fee
      )}% - x${selOpt?.installments} de R$ ${addThousandSeparator(
        selOpt?.installmentValue
      )} - ${gracePeriod} ${gracePeriodUnit} - ${selOpt?._id}`
    );
  };

  return (
    <Fragment>
      <form style={{ zIndex: 502 }} className={classes.formRoot3}>
        <Button
          className="kit-payment__form-data-gen-order-btn"
          variant="contained"
          color="primary"
          onClick={openWhatsappHandler}
        >
          <WhatsAppIcon /> CONTRATAR FINANCIAMENTO
        </Button>
      </form>
    </Fragment>
  );
};
